/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespNullSearchResultsHeader_itemSearch = {
    readonly relatedSearchResults: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly item: {
                    readonly serviceId: string | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedSearchSuggestions_itemSearch" | "SbSharedTitle_itemSearch">;
    readonly " $refType": "SbRespNullSearchResultsHeader_itemSearch";
};
export type SbRespNullSearchResultsHeader_itemSearch$data = SbRespNullSearchResultsHeader_itemSearch;
export type SbRespNullSearchResultsHeader_itemSearch$key = {
    readonly " $data"?: SbRespNullSearchResultsHeader_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespNullSearchResultsHeader_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespNullSearchResultsHeader_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "relatedSearchResultsItemConnection",
      "kind": "LinkedField",
      "name": "relatedSearchResults",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "relatedSearchResultsItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemSearchResult",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "item",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '4e0eacdbec5b7e111bba528804bc3491';
export default node;
